import axiosInstance from "@/plugins/axios";
import { normalizeContentFeedTitle } from "@/utils/contentFeedType.js";

export const actions = {
    async createContentFeed(contentFeedData) {
        try {
            const payload = {
                ...contentFeedData,
                title: normalizeContentFeedTitle(contentFeedData?.title, contentFeedData?.type),
            };
            const response = await axiosInstance.post(`/api/content-feeds`, payload);
            return response.data.data;
        } catch (error) {
            console.error('Error creating content feed:', error);
            throw error;
        }
    },

    async fetchContentFeeds(params = {}) {
        this.contentFeedsLoading = true;
        try {
            const { type, ...rest } = params;
            const query = { ...rest };
            if (type) query.type = type;
            const response = await axiosInstance.get('/api/content-feeds', { params: query });
            this.contentFeeds = response.data?.data ?? response.data ?? [];
            return this.contentFeeds;
        } catch (error) {
            console.error('Error fetching content feeds:', error);
            throw error;
        } finally {
            this.contentFeedsLoading = false;
        }
    },

    async searchStudio(params) {
        const response = await axiosInstance.get('/api/content-feeds/studio/search', { params });
        return response.data.data;
    },

    async browseStudio(params) {
        const response = await axiosInstance.get('/api/content-feeds/studio/browse', { params });
        return response.data;
    },

    async fetchStudioFilters(params) {
        const response = await axiosInstance.get('/api/content-feeds/studio/filters', { params });
        return response.data.data;
    },

    async fetchStudioSuggestions(languageId, refresh = false) {
        const response = await axiosInstance.get('/api/content-feeds/studio/suggestions', {
            params: { language_id: languageId, refresh: refresh ? 1 : 0 },
            timeout: 120000,
        });
        return response.data.data;
    },

    async fetchStudioSuggestionItems(params) {
        const response = await axiosInstance.get('/api/content-feeds/studio/suggestions/items', { params, timeout: 120000 });
        return response.data.data;
    },

    /** The feed as a phone would load it, for the posting preview; the managed list is left alone. */
    async fetchFeedPreview(languageId) {
        const response = await axiosInstance.get('/api/content-feeds', { params: { language_id: languageId, per_page: 15 } });
        return response.data?.data ?? [];
    },

    async fetchStudioInsights(languageId) {
        const response = await axiosInstance.get('/api/content-feeds/studio/insights', { params: { language_id: languageId } });
        return response.data.data;
    },

    async publishFromStudio(payload) {
        const response = await axiosInstance.post('/api/content-feeds/studio/publish', payload);
        return response.data.data;
    },

    async deleteContentFeed(id) {
        await axiosInstance.delete(`/api/content-feeds/${id}`);
        this.contentFeeds = this.contentFeeds.filter((f) => String(f.id) !== String(id));
    },

    /** The home feed and the Kids section are ordered apart; the other one keeps its place in the list. */
    async reorderSection(orderIds) {
        await axiosInstance.patch('/api/content-feeds/reorder', { order: orderIds });
        const moved = new Set(orderIds.map(String));
        const byId = new Map(this.contentFeeds.map((f) => [String(f.id), f]));
        this.contentFeeds = [
            ...orderIds.map((id) => byId.get(String(id))).filter(Boolean),
            ...this.contentFeeds.filter((f) => !moved.has(String(f.id))),
        ];
    },

    async reorderContentFeeds(orderIds) {
        await axiosInstance.patch('/api/content-feeds/reorder', { order: orderIds });
        const byId = new Map(this.contentFeeds.map((f) => [String(f.id), f]));
        this.contentFeeds = orderIds.map((id) => byId.get(String(id))).filter(Boolean);
    },
};
